<div *ngIf='sessionData && dataReady' class='ViewMessage container pt-3'>
  <div class='d-flex flex-row justify-content-between'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]='getBackRoute()'
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a class='Breadcrumbs-item'>{{ getResponseStatus() }}</a>
      </div>
    </div>
    <div *ngIf="sessionData && sessionData.user_type === 'vsm'">
        <div
          *ngIf='lockedBannerState === locketBannerStates.SELF; else other'
          [class.alert-danger]='vsmRemainingTime < 10 * 1000'
          [class.alert-info]='vsmRemainingTime >= 10 * 1000'
          class='alert'>
          <p class='mb-0'>
            This message have been locked for you only. You have
            <b>{{ vsmRemainingMinutes }}:{{ vsmRemainingSeconds }}</b> to work on
            it!
          </p>
        </div>
        <ng-template #other>
          <div class='alert alert-danger'>
            <p class='mb-0'>
              This message is locked by <b>{{ lockedByUser }}</b
            >!
            </p>
          </div>
        </ng-template>
      <ng-container *ngIf="isMessageSpam && !isUnmatchedMessage()">
        <div class='alert alert-warning d-flex flex-column align-items-center'>
          <p>This message is classified as <b>SPAM</b>.</p>
          <ul>
          <li>If you decide to keep it as SPAM and directly release, the message will land in user's spam inbox</li>
          <li>If you mark it as "NOT SPAM" you will be able to proceed and pick a proper reply action</li>
          </ul>
          <app-button
            class="mt-2"
            [color]="'red'"
            [text]="'Mark as Not Spam'"
            [Click]="markAsNotSpam.bind(this)"></app-button>
        </div>
      </ng-container>
    </div>

      <ng-container
        *ngIf="
          contactGroup === 'temp' && isUnmatchedMessage() &&
          (sessionData.user_type === 'vsm' || sessionData.user_type === 'user');
          else normalResponse
        ">
        <app-button
          *ngIf="sessionData.user_type !== 'vsm'; else vsmButton"
          [Click]='responseButtonProperties.onClick'
          [color]='responseButtonProperties.color'
          [size]='responseButtonProperties.size'
          [text]='responseButtonProperties.text'></app-button>
        <ng-template #vsmButton>
          <app-button-select
            *ngIf='
              vsmResponseButtonProperties &&
              vsmResponseButtonProperties.buttonProperties
            '
            [buttonProperties]='vsmResponseButtonProperties.buttonProperties'
            [items]='vsmResponseButtonProperties.items'></app-button-select>
        </ng-template>
      </ng-container>
      <ng-template #normalResponse>
        <app-button-select
          *ngIf="
            sessionData.user_type !== 'manager' &&
            sessionData.user_type !== 'partner' &&
            sessionData.user_type !== 'master' &&
            responseButtonSelect &&
            responseButtonSelect.buttonProperties &&
            (sessionData.user_type !== 'vsm' ||
              lockedBannerState === locketBannerStates.SELF)
          "
          [buttonProperties]='responseButtonSelect.buttonProperties'
          [items]='responseButtonSelect.items'></app-button-select>
      </ng-template>
  </div>
  <ng-container *ngIf='emptyState; else data'>
    <p class='ViewMessage__no-data text-center'>No data to display</p>
  </ng-container>
  <ng-template #data>
    <div class='ViewMessage__container mt-5 p-5'>
      <div class='w-100 d-flex flex-column align-items-end justify-content-end'>
        <div class='ViewMessage__container__nav mb-5'>
          <app-button
            *ngIf='preMessageId'
            [Click]="onNavigationButtonClick.bind(this, 'prev')"
            [color]="'blue'"
            [text]="'Previous'"></app-button>
          <app-button
            class="ms-3"
            *ngIf='nextMessageId'
            [Click]="onNavigationButtonClick.bind(this, 'next')"
            [color]="'blue'"
            [text]="'Next'"></app-button>
        </div>
      </div>
      <div class="d-flex flex-column align-items-end justify-content-end">
        <div *ngIf='hasResponseStatus()' class='ViewMessage__container__status mb-3 d-flex flex-column justify-content-end align-items-end'>
          <p class='text-left text-capitalize mb-3'>
            <b>Current Contact Status: </b><span>{{ getResponseStatus(true) }}</span>
          </p>
          <p *ngIf='!isUnmatchedMessage() && shouldShowNextServiceDate()' class='text-left ms-3 mb-3'>
            <b>Next Email Date: </b
            ><span>{{
              getNextEmailDate()
                | timezone: 'MM/DD/YYYY' : sessionData.time_zone
            }}</span>
          </p>
          <p *ngIf='getMessageCampaing()' class='ms-3 mb-0'>
            <b>Campaign: </b><span>{{ getMessageCampaing() }}</span>
          </p>
        </div>
        <div class='ViewMessage__container__plain'>
          <mat-checkbox
            (change)='viewAsPlain = $event.checked'
            [value]='viewAsPlain.toString()'
          >View as plain
          </mat-checkbox
          >
        </div>
      </div>
      <div class='ViewMessage__container__message mt-5'>
        <ng-container *ngIf='messages && messages.length > 0'>
          <app-message-viewer
            *ngFor='let message of messages; let i = index'
            [asPlainText]='viewAsPlain'
            [message]='message'
            [sessionData]='sessionData'
            [showReleaseNote]='i === 0'></app-message-viewer>
        </ng-container>

        <div class='ViewMessage__container__message__paginator mt-5 d-flex flex-row justify-content-between'>
          <ng-container *ngIf='currenMessagesPage && currenMessagesPage > 1'>
            <button (click)='getMessagesPage(-1)' class='btn btn-secondary'>Show newer</button>
          </ng-container>

          <ng-container *ngIf='hasMoreMessages'>
            <button (click)='getMessagesPage(1)' class='btn btn-primary'>Show older messages</button>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</div>
